import { DataTable } from "primereact/datatable";
import {
  phoneOrderColumns,
  rowExpansionPhoneOrderLineItemsColumns
} from "../../constants/table-columns/tableColumns";
import { useEffect, useRef, useState } from "react";
import Spinner from "../../components/spinner/spinner";
import { Toast } from "primereact/toast";
import * as constants from "../../constants/constants";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { format, parseISO } from "date-fns";

import { Tag } from "primereact/tag";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import styles from ".//PhoneOrderTable.module.scss";
import { Form, Formik } from "formik";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { phoneOrderMockData } from "../../util/mock-data/PhoneOrderMockData";

const initialValue = {
  purchaseOrderNumber: null,
  tradingPartnerName: null,
  requestedShippingStartDate: null,
  requestedShippingEndDate: null,
  region: null
};

const PhoneOrderTable = (props) => {
  const navigateToAddNewPhoneOrder = (
    showPhoneOrderTable,
    showAddNewPhoneOrder
  ) => {
    props?.alterComponent(showPhoneOrderTable, showAddNewPhoneOrder);
  };

  const toast = useRef(null);
  const formRef = useRef(null);
  const [showSpinner, setShowSpinner] = useState(false);
  const [pdfOrderData, setPdfOrderData] = useState([]);
  const [expandedRows, setExpandedRows] = useState(null);
  const [allExpanded, setAllExpanded] = useState(false);
  const [disableFields, setDisableFields] = useState(false);

  useEffect(() => {
    fetchPdfOrders();
  }, []);

  function formatDateTime(isoString) {
    const date = parseISO(isoString);
    return format(date, "yyyy-MM-dd");
  }

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const fetchPdfOrders = async (formBody) => {
    try {
      setShowSpinner(true);

      formBody = {
        purchaseOrderNumber: formBody?.purchaseOrderNumber
          ? formBody?.purchaseOrderNumber
          : null,
        tradingPartnerName: formBody?.tradingPartnerName
          ? formBody?.tradingPartnerName
          : null,
        requestedShippingStartDate: formBody?.requestedShippingStartDate
          ? formatDate(formBody?.requestedShippingStartDate)
          : null,
        requestedShippingEndDate: formBody?.requestedShippingEndDate
          ? formatDate(formBody?.requestedShippingEndDate)
          : null,
        region: formBody?.region ? formBody?.region : null
      };

      // let result = await getEmailOrders(formBody);
      let result = phoneOrderMockData;
      setPdfOrderData(result);

      setShowSpinner(false);
    } catch (error) {
      setShowSpinner(false);
      setPdfOrderData([]);

      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
        life: 4000
      });
    }
  };

  const rowExpansionTemplate = (data) => {
    return (
      <div className="">
        <DataTable value={data.lineItems} emptyMessage={constants.emptyMessage}>
          {rowExpansionPhoneOrderLineItemsColumns.map((col, index) => (
            <Column
              key={index}
              field={col.field}
              header={col.header}
              sortable={col.sort}
              style={{ minWidth: col.minWidth }}
              body={col.value}
            />
          ))}
        </DataTable>
      </div>
    );
  };

  const toggleRows = () => {
    if (allExpanded) {
      setExpandedRows(null);
      setAllExpanded(false);
    } else {
      let newExpandedRows = {};
      pdfOrderData.forEach((p) => (newExpandedRows[`${p.id}`] = true));
      setExpandedRows(newExpandedRows);
      setAllExpanded(true);
    }
  };

  const requestedShippingDateFormat = (rowData) => {
    return formatDateTime(rowData.shipDate);
  };

  const requestedReceiptDateFormat = (rowData) => {
    return formatDateTime(rowData.receiptDate);
  };

  return (
    <>
      {showSpinner && <Spinner />}

      <br></br>

      <Formik
        initialValues={initialValue}
        onSubmit={(values) => {
          setShowSpinner(true);
          fetchPdfOrders(values);
        }}
        innerRef={formRef}
      >
        {({ values, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit} ref={formRef}>
            <div className="grid">
              <div className="col-12 md:col-2">
                <div className={styles.formLabelContainer}>
                  <label htmlFor="purchaseOrderNumber">
                    <span className={styles.formLabel}>PO Number</span>
                  </label>
                </div>
                <div className="p-inputgroup flex-1">
                  <span className="p-inputgroup-addon">
                    <i className="pi pi-search"></i>
                  </span>
                  <InputText
                    id="purchaseOrderNumber"
                    placeholder="PO Number"
                    value={values?.purchaseOrderNumber}
                    onChange={handleChange}
                    className={`${styles.inputField} ${styles.formControl} ${styles.noBorder}`}
                  />
                </div>
              </div>

              <div className="col-12 md:col-4">
                <div className={styles.formLabelContainer}>
                  <label htmlFor="tradingPartnerName">
                    <span className={styles.formLabel}>
                      Trading Partner Name
                    </span>
                  </label>
                </div>
                <div className="p-inputgroup flex-1">
                  <span className="p-inputgroup-addon">
                    <i className="pi pi-search"></i>
                  </span>
                  <InputText
                    id="tradingPartnerName"
                    placeholder="Trading Partner Name"
                    value={values?.tradingPartnerName}
                    onChange={handleChange}
                    className={`${styles.inputField} ${styles.formControl} ${styles.noBorder}`}
                  />
                </div>
              </div>

              <div className="col-12 md:col-2">
                <div className={styles.formLabelContainer}>
                  <label htmlFor="region">
                    <span className={styles.formLabel}>Region</span>
                  </label>
                </div>
                <div className="p-inputgroup flex-1">
                  <span className="p-inputgroup-addon">
                    <i className="pi pi-search"></i>
                  </span>
                  <InputText
                    id="region"
                    placeholder="Region"
                    value={values?.region}
                    onChange={handleChange}
                    className={`${styles.inputField} ${styles.formControl} ${styles.noBorder}`}
                  />
                </div>
              </div>

              <div className="col-12 md:col-2">
                <div className={styles.formLabelContainer}>
                  <label htmlFor="requestedShippingStartDate">
                    <span className={styles.formLabel}>Requested Shipping</span>
                  </label>
                </div>
                <Calendar
                  id="requestedShippingStartDate"
                  value={values?.requestedShippingStartDate}
                  onChange={handleChange}
                  disabled={disableFields}
                  placeholder="Start Date"
                  maxDate={formRef?.current?.values?.requestedShippingEndDate}
                />
              </div>
              <div className="col-12 md:col-2">
                <div className={styles.formLabelContainer}></div>
                <Calendar
                  id="requestedShippingEndDate"
                  value={values?.requestedShippingEndDate}
                  onChange={handleChange}
                  disabled={disableFields}
                  placeholder="End Date"
                  minDate={formRef?.current?.values?.requestedShippingStartDate}
                />
              </div>
            </div>

            <div
              className="flex justify-content-end flex-wrap gap-3"
              style={{ marginTop: "1rem", marginBottom: "1rem" }}
            >
              <div className="flex align-items-center justify-content-center">
                <div className={styles.formLabelContainer}></div>
                <Button
                  label="Search"
                  type="submit"
                  size="medium"
                  className={styles.primaryBtn}
                />
              </div>
              <div className="flex align-items-center justify-content-center">
                <div className={styles.formLabelContainer}></div>
                <Button
                  label="Reset"
                  type="button"
                  size="medium"
                  onClick={(e) => {
                    formRef.current.setValues({
                      purchaseOrderNumber: "",
                      tradingPartnerName: "",
                      requestedShippingStartDate: null,
                      requestedShippingEndDate: null,
                      region: ""
                    });
                    fetchPdfOrders({
                      purchaseOrderNumber: "",
                      tradingPartnerName: "",
                      requestedShippingStartDate: null,
                      requestedShippingEndDate: null,
                      region: ""
                    });
                    setDisableFields(false);
                  }}
                  className={styles.resetBtn}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>

      <div>
        <Button
          label="Create New Order"
          onClick={() => navigateToAddNewPhoneOrder(false, true)}
        ></Button>
      </div>

      <br></br>

      <DataTable
        value={pdfOrderData}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        paginator={constants.paginator}
        rows={constants.defaultRows}
        rowsPerPageOptions={constants.rowsPerPageOptions}
        paginatorTemplate={constants.paginatorTemplate}
        currentPageReportTemplate={constants.currentPageReportTemplate}
        emptyMessage={constants.emptyMessage}
        dataKey="id"
        scrollHeight="30vw"
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowExpansionTemplate={rowExpansionTemplate}
      >
        <Column
          header={
            <Button
              className={allExpanded ? "pi pi-angle-down" : "pi pi-angle-right"}
              style={{
                fontSize: "1.3rem",
                color: "#6c757d",
                backgroundColor: "#f8f9fa",
                border: "none",
                padding: "2px"
              }}
              onClick={toggleRows}
            ></Button>
          }
          style={{ width: "10px" }}
          expander={true}
        />

        {phoneOrderColumns.map((col, index) => (
          <Column
            key={index}
            field={col.field}
            header={col.header}
            sortable={col.sort}
            style={{ minWidth: col.minWidth }}
            body={
              col.field.toLocaleLowerCase() === "shipdate"
                ? requestedShippingDateFormat
                : col.field.toLocaleLowerCase() === "receiptdate"
                ? requestedReceiptDateFormat
                : col.value
            }
          />
        ))}
      </DataTable>

      <Toast ref={toast} position="center" />
    </>
  );
};

export default PhoneOrderTable;
